/** Format a @db.Date (or null) for admin tables (calendar day in UTC). */
export function formatDate(d: Date | null, locale?: string): string {
  if (!d) return "—";
  return d.toLocaleDateString(locale, {
    year: "numeric",
    month: "short",
    day: "numeric",
    timeZone: "UTC",
  });
}

/** Calendar day in UTC, comparable to @db.Date values from Prisma. */
export function utcDateKey(d: Date): string {
  return d.toISOString().slice(0, 10);
}

/** Enabled unless start is strictly after today or end is strictly before today (UTC keys). */
const isLocationDateRangeActive = (
  startDateKey: string | null,
  endDateKey: string | null,
  todayKey: string,
): boolean => {
  if (startDateKey != null && startDateKey > todayKey) return false;
  if (endDateKey != null && endDateKey < todayKey) return false;
  return true;
};

/** Enabled unless start is strictly after today or end is strictly before today (UTC). */
export function isLocationCurrentlyEnabled(
  startDate: Date | null,
  endDate: Date | null,
  now: Date,
): boolean {
  return isLocationDateRangeActive(
    startDate != null ? utcDateKey(startDate) : null,
    endDate != null ? utcDateKey(endDate) : null,
    utcDateKey(now),
  );
}

/**
 * Whether a location counts as “active” by its UTC calendar start/end bound strings
 * (same rules as {@link isLocationCurrentlyEnabled}).
 */
export function isLocationDateActive(
  startDate: string | null,
  endDate: string | null,
  now: Date = new Date(),
): boolean {
  return isLocationDateRangeActive(startDate, endDate, utcDateKey(now));
}
